import * as React from 'react'
import AuthStore from '../stores/AuthStore'

interface PromoAdModalState {
  isOpen: boolean
}

export default class PromoAdModal extends React.Component<{}, PromoAdModalState> {
  state: PromoAdModalState = {
    isOpen: false,
  }

  componentDidMount() {
    this.checkPromoVisibility()
  }

  private get storageKeyTime(): string {
    const user = AuthStore.getUser()
    return user ? `letip_promo_dismissed_at_${user.username}` : 'letip_promo_dismissed_at'
  }

  private checkPromoVisibility = () => {
    try {
      const lastDismissedTime = localStorage.getItem(this.storageKeyTime)

      if (!lastDismissedTime) {
        this.setState({ isOpen: true })
        return
      }

      const parsedTime = parseInt(lastDismissedTime, 10)

      if (isNaN(parsedTime)) {
        this.setState({ isOpen: true })
        return
      }

      this.setState({ isOpen: Date.now() >= this.nextDisplayTime(parsedTime) })
    } catch (e) {
      this.setState({ isOpen: true })
    }
  }

  private nextDisplayTime = (dismissedAt: number): number => {
    const dayOfMonth = new Date(dismissedAt).getDate()
    const next = new Date(dismissedAt)

    next.setMonth(next.getMonth() + 1)

    if (next.getDate() < dayOfMonth) {
      next.setDate(0)
    }

    return next.getTime()
  }

  private handleClose = () => {
    try {
      localStorage.setItem(this.storageKeyTime, Date.now().toString())
    } catch (e) {
      // Fail silently if browser storage is unavailable
    }
    this.setState({ isOpen: false })
  }

  render() {
    if (!this.state.isOpen) {
      return null
    }

    return (
      <div style={styles.overlay}>
        <div style={styles.modal}>
          <button 
            onClick={this.handleClose} 
            style={styles.closeButton} 
            aria-label="Close advertisement"
          >
            &times;
          </button>
          <a href="https://convention.letip.com" target="_blank" rel="noopener noreferrer">
            <img
              src={'/letip-convention-2027.jpeg'}
              alt="LeTip Convention 2027"
              style={styles.image}
            />
          </a>
        </div>
      </div>
    )
  }
}

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, // High z-index to render on top of other content
  },
  modal: {
    position: 'relative',
    backgroundColor: '#fff',
    padding: '10px',
    borderRadius: '8px',
    maxWidth: '90%',
    maxHeight: '90%',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '-15px',
    right: '-15px',
    background: '#333',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '80vh',
    objectFit: 'contain',
    borderRadius: '4px',
  },
}